var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm.showBackButton
        ? _c("question-back-button", {
            on: {
              click: function ($event) {
                return _vm.$emit("prev")
              },
            },
          })
        : _c("div"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-page-footer__right" },
        [
          _vm.showSkipButton
            ? _c("skip-button", {
                on: {
                  click: function ($event) {
                    return _vm.$emit("skip")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.rightButtonComponent)
            ? _c(_vm.rightButtonComponent, {
                tag: "component",
                on: {
                  click: function (event) {
                    return _vm.$emit(event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-page-footer__powered-by" },
        [
          _vm.showPoweredBy
            ? _c("powered-by", {
                attrs: {
                  "chatchamp-link-clickable": _vm.chatchampLinkClickable,
                  "customer-id": _vm.customerId,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }